export default __webpack_public_path__ + "static/media/Verified.d6cf5942.svg";